import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { SharedModule } from "../../../shared/shared.module";
import { CreateTicketComponent } from "./create-ticket/create-ticket.component";
import { ManageTicketsComponent } from "./manage-tickets/manage-tickets.component";
import { TicketCommentsComponent } from "./manage-tickets/ticket-comments/ticket-comments.component";
import { TicketsComponent } from "./tickets.component";

@NgModule({
  declarations: [CreateTicketComponent, ManageTicketsComponent, TicketCommentsComponent, TicketsComponent],
  imports: [CoreModule, SharedModule],
  exports: [CreateTicketComponent, ManageTicketsComponent, TicketCommentsComponent, TicketsComponent],
})
export class TicketModule {}
